import React from 'react';
import tenantStorage from '../../utils/tenantStorage';
import './rtCommon.css';

export function getGreetingName() {
  return (
    tenantStorage.getItem('staffName') ||
    tenantStorage.getItem('userName') ||
    tenantStorage.getItem('username') ||
    'there'
  );
}

/**
 * Sticky top greeting bar: "Hi {name}".
 * Profile icon stays via Menu / UserProfileMenu.
 */
const RTHeader = ({ name }) => {
  const greetingName = name || getGreetingName();
  return (
    <div className="rt-title-row rt-hi-header">
      <h2 className="rt-title">Hi, {greetingName}!</h2>
    </div>
  );
};

export default RTHeader;
